import { ProfileState } from '../../store/state';
import { ProfileAction, ProfileActions } from '../actions/profile.action';

const initialState: ProfileState = null;

const profileReducer = (state: ProfileState = initialState, action: ProfileAction): ProfileState => {
  switch (action.type) {
    case ProfileActions.LoadUserProfileInfo:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case ProfileActions.UpdateUserInfoSucceed:
    case ProfileActions.LoadUserProfileInfoSucceed:
      return {
        ...state,
        isLoading: false,
        error: null,
        userInfo: action.payload,
      };
    case ProfileActions.UpdateUserInfoFailed:
    case ProfileActions.LoadUserProfileInfoFailed:
      return {
        ...state,
        isLoading: false,
        userInfo: null,
        error: action.payload,
      };
    case ProfileActions.ResetUserState:
      return initialState;
    case ProfileActions.UpdateUserProfileInfo:
      return {
        ...state,
        saving: true,
        saved: false,
      };
    case ProfileActions.UpdateUserProfileInfoSucceed:
      return {
        ...state,
        userInfo: action.payload,
        saving: false,
        saved: true,
      };
    case ProfileActions.UpdateUserProfileInfoFailed:
      return {
        ...state,
        saving: false,
        saved: false,
        error: action.payload,
      };
    case ProfileActions.ResetProfileSavingState:
      return {
        ...state,
        saving: false,
        saved: false,
        error: null,
      };
    default:
      return state;
  }
};

export default profileReducer;
